// "Reason for Correction" coded values per programme (GP Contract v3-2 CDM spec,
// HL7 local table X0339). The reason is carried in the CDR clinical message only
// (PCRS does not require it) and the field is non-mandatory in the spec.
// Values are sent verbatim and must match the BE correctionReason enum.

// CDM Treatment — single value X0339-1.
export const CDM_CORRECTION_REASON_OPTIONS = [
  { label: "Incorrect diagnosis", value: "INCORRECT_DIAGNOSIS" },
];

// OCF — single value X0339-2.
export const OCF_CORRECTION_REASON_OPTIONS = [
  { label: "Incorrect outcome", value: "INCORRECT_OUTCOME" },
];

// PP / PP-Pregnancy — X0339-2 / X0339-3. Per HSE feedback the only PP
// corrections are "incorrect outcome" and "incorrect registration reason";
// "add a direct entry registration reason" is not offered.
export const PP_CORRECTION_REASON_OPTIONS = [
  { label: "Incorrect outcome", value: "INCORRECT_OUTCOME" },
  {
    label: "Incorrect registration reason",
    value: "INCORRECT_REGISTRATION_REASON",
  },
];

export const CDM_DEFAULT_CORRECTION_REASON = "INCORRECT_DIAGNOSIS";
export const OCF_DEFAULT_CORRECTION_REASON = "INCORRECT_OUTCOME";
